import React, { useEffect, useRef } from "react";
import "./style.css";

export const CurlyBraceDivider = ({
  color = "black",
  width,
  height = 50,
  direction = "down",
  shrink_margin = false,
}) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    let color_hex;
    switch (color) {
      case 'black':
        color_hex = '#454545';
        break;
      case 'grey':
        color_hex = '#dadce0';
        break;
      case 'green':
        color_hex = '#115453';
        break;
      case 'tan':
        color_hex = '#F6E6DB';
        break;
      case 'red':
        color_hex = '#f27e7e';
        break;
      default:
        color_hex = '#454545';
        break;
    }

    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");

    const resizeCanvas = () => {
      const parent = canvas.parentElement;
      const isHorizontal = direction === "left" || direction === "right";

      // For horizontal orientation, swap width and height logic
      if (isHorizontal) {
        canvas.height = parent.clientHeight;
        canvas.width = width || 50; // Default width for horizontal
      } else {
        canvas.width = width || parent.clientWidth;
        canvas.height = height;
      }

      const space = 5;
      const radius = 7;

      // Calculate middle point based on orientation
      const middlePoint = isHorizontal
        ? canvas.height / 2
        : canvas.width / 2;

      context.clearRect(0, 0, canvas.width, canvas.height);
      context.lineWidth = 2;
      context.strokeStyle = color_hex;
      context.beginPath();

      // Draw the brace based on direction
      switch (direction) {
        case "down":
          context.moveTo(space, 20 + radius);
          context.arcTo(space, 20, space + radius, 20, radius);
          context.lineTo(middlePoint - radius, 20);
          context.arcTo(middlePoint, 20, middlePoint, 20 - radius, radius);
          context.arcTo(middlePoint, 20, middlePoint + radius, 20, radius);
          context.lineTo(canvas.width - space - radius, 20);
          context.arcTo(canvas.width - space, 20, canvas.width - space, 20 + radius, radius);
          break;

        case "up":
          context.moveTo(space, height - 20 - radius);
          context.arcTo(space, height - 20, space + radius, height - 20, radius);
          context.lineTo(middlePoint - radius, height - 20);
          context.arcTo(middlePoint, height - 20, middlePoint, height - 20 + radius, radius);
          context.arcTo(middlePoint, height - 20, middlePoint + radius, height - 20, radius);
          context.lineTo(canvas.width - space - radius, height - 20);
          context.arcTo(canvas.width - space, height - 20, canvas.width - space, height - 20 - radius, radius);
          break;

        case "left":
          context.moveTo(20 + radius, space);
          context.arcTo(20, space, 20, space + radius, radius);
          context.lineTo(20, middlePoint - radius);
          context.arcTo(20, middlePoint, 20 - radius, middlePoint, radius);
          context.arcTo(20, middlePoint, 20, middlePoint + radius, radius);
          context.lineTo(20, canvas.height - space - radius);
          context.arcTo(20, canvas.height - space, 20 + radius, canvas.height - space, radius);
          break;

        case "right":
          context.moveTo(canvas.width - 20 - radius, space);
          context.arcTo(canvas.width - 20, space, canvas.width - 20, space + radius, radius);
          context.lineTo(canvas.width - 20, middlePoint - radius);
          context.arcTo(canvas.width - 20, middlePoint, canvas.width - 20 + radius, middlePoint, radius);
          context.arcTo(canvas.width - 20, middlePoint, canvas.width - 20, middlePoint + radius, radius);
          context.lineTo(canvas.width - 20, canvas.height - space - radius);
          context.arcTo(canvas.width - 20, canvas.height - space, canvas.width - 20 - radius, canvas.height - space, radius);
          break;
      }

      context.stroke();
    };

    resizeCanvas();
    window.addEventListener("resize", resizeCanvas);

    return () => {
      window.removeEventListener("resize", resizeCanvas);
    };
  }, [color, width, height, direction]);

  return (
    <>
      {direction === "left" || direction === "right" ? (
        <div className="curly-brace-left-right-container">
          <canvas
            className={`canvas ${shrink_margin ? 'shrink-margin' : ''}`}
            ref={canvasRef}
            height={direction === "left" || direction === "right" ? "100%" : height}
            />
        </div>
      ) : (
        <canvas
          className={`canvas ${shrink_margin ? 'shrink-margin' : ''}`}
          ref={canvasRef}
          height={height}
        />
      )}
    </>
  );
};

// export default CurlyBrace;
